import ApiService from '@/services/core/api.service'

const CropFungicideService = {
  async get (query) {
    return ApiService.get(`admin/crop-fungicides?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/crop-fungicides', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/crop-fungicides/${payload.id}`, payload)
  }
}

export default CropFungicideService
